import { BadgeSearchForm } from './BadgeSearchForm'
import { withBadgeSearchForm } from './withBadgeSearchForm'

const ConnectedBadgeSearchForm = withBadgeSearchForm(BadgeSearchForm)

export { ConnectedBadgeSearchForm as BadgeSearchForm }
